<template>
  <div>
    <!-- <div v-wechat-title="$route.meta.title = title"></div> -->
    <div class="policy">
      <div v-html="privacyPolicy"></div>
    </div>
    <!-- <BottomBar></BottomBar> -->
  </div>
</template>
<script>

// import BottomBar from '@/components/BottomBar'
import api from '@/api'

export default {
  components: {
    // BottomBar
  },
  data () {
    return {
      // id: '',
      // title:'',
      privacyPolicy:'隐私协议',
      userPolicy:'',
    }
  },
   created: function () {
    // this.getUid()
  },
  mounted: function () {
    this.getDetail()
  },
  methods:{
    getUid () {
      this.id = this.$route.params.id
    },
    getDetail () {
      api.policyApi().then(res => {
        if(res.code == 200){
          // console.log(res)
          res = res.result
          if(res&&res.length)
          res.map(v=>{
            if(v.id==2) this.privacyPolicy = v.agreementContent
            if(v.id==1) this.userPolicy = v.agreementContent
          })
        }else{
          this.$toast(res.message)
        }
      })
      .catch(e => {
        this.$toast(e)
      })
    },
  }
}
</script>
<style lang="less" scope>
  @black:#333;
  @gray:#666;
  @blue: #4065E0;
  .policy{
    background: #fff;
    margin-bottom: 83px;
    padding: 16px;
    img{
      width: 100%;
    }
    video {
      width: 100%;
    }
  }
</style>
